import Header from 'components/RecurringOrderSuggestionsModal/Sections/Header/styled';

export default Header;
